import React, { useMemo } from 'react';

const RushCheckbox = ({ serviceName, serviceKey, onCheckedChange, checked }) => {
  const checkboxId = useMemo(() => `${serviceKey}Rush`, [serviceKey]);
  return (
    <>
      <label htmlFor={checkboxId} className="checkbox-label">
        <input
          checked={checked}
          onChange={onCheckedChange}
          name={checkboxId}
          id={checkboxId}
          type="checkbox"
          className="custom-checkbox"
        />
        <div className="checkbox-content">
          <p>
            Rush <span>(May incur additional costs)</span>
          </p>
        </div>
      </label>
    </>
  );
};

export default RushCheckbox;
